function debounce(bdtv_fac9f7433679, bdtv_cc2b9f084f27) {
  let bdtv_4ce59abb11ac;
  return (...bdtv_6243f5525d66) => {
    bdtv_6243f5525d66[0]?.target.classList.remove("bdt-zuvu-entrada2");
    clearTimeout(bdtv_4ce59abb11ac);
    bdtv_4ce59abb11ac = setTimeout(() => bdtv_fac9f7433679.apply(this, bdtv_6243f5525d66), bdtv_cc2b9f084f27);
  };
}
function validateRequiredInputs(bdtv_7be5a68ffe1f = document) {
  const bdtv_c01853813cc9 = bdtv_7be5a68ffe1f.querySelectorAll(`
    input[required][type="text"],
    input[required][type="email"], 
    input[required][type="password"],
    input[required][type="tel"],
    textarea[required],
    select[required]
  `);

  let bdtv_96e7873ec623 = true;
  const bdtv_5be9d9358f08 = {
    text: [],
    email: [],
    tel: [],
    password: [],
    textarea: [],
    select: [],
  };

  bdtv_c01853813cc9.forEach((bdtv_adb758caed43) => {
    const bdtv_f30719535bf3 =
      bdtv_adb758caed43.tagName.toLowerCase() === "textarea"
        ? "textarea"
        : bdtv_adb758caed43.tagName.toLowerCase() === "select"
        ? "select"
        : bdtv_adb758caed43.type;
    if (bdtv_5be9d9358f08[bdtv_f30719535bf3]) {
      bdtv_5be9d9358f08[bdtv_f30719535bf3].push(bdtv_adb758caed43);
    }
  });

  Object.keys(bdtv_5be9d9358f08).forEach((bdtv_7613f86186d4) => {
    bdtv_5be9d9358f08[bdtv_7613f86186d4].forEach((bdtv_efd898249da8) => {
      const bdtv_651faf95525f = validateInputByType(bdtv_efd898249da8, bdtv_7613f86186d4);
      if (!bdtv_651faf95525f) {
        bdtv_96e7873ec623 = false;
      }
    });
  });

  return bdtv_96e7873ec623;
}

function validateInputByType(bdtv_ca0e6e8fe3a6, bdtv_5f15807ee2ec) {
  let bdtv_e3eb715af6a6 = true;

  if (bdtv_ca0e6e8fe3a6.value.trim()) {
    switch (bdtv_5f15807ee2ec) {
      case "email":
        if (!isValidEmail(bdtv_ca0e6e8fe3a6.value)) {
          bdtv_e3eb715af6a6 = false;
        }
        break;
      case "tel":
        if (!isValidPhone(bdtv_ca0e6e8fe3a6.value)) {
          bdtv_e3eb715af6a6 = false;
        }
        break;
      case "text":
      case "textarea":
        if (bdtv_ca0e6e8fe3a6.value.trim().length < 2) {
          bdtv_e3eb715af6a6 = false;
        }
        break;
      case "select":
        if (!bdtv_ca0e6e8fe3a6.value || bdtv_ca0e6e8fe3a6.value === "" || bdtv_ca0e6e8fe3a6.value === "0") {
          bdtv_e3eb715af6a6 = false;
        }
        break;
    }
  } else if (bdtv_ca0e6e8fe3a6.hasAttribute("required")) {
    bdtv_e3eb715af6a6 = false;
  }

  if (bdtv_e3eb715af6a6) {
    removeErrorMessage(bdtv_ca0e6e8fe3a6);
  } else {
    showErrorMessage(bdtv_ca0e6e8fe3a6);
  }

  return bdtv_e3eb715af6a6;
}

function isValidEmail(bdtv_e7015afad749) {
  const bdtv_e76df1f42021 = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  return bdtv_e76df1f42021.test(bdtv_e7015afad749);
}

function isValidPhone(bdtv_16ca7785d54c) {
  const bdtv_5ff6936e1587 = /^[0-9\-]*$/;
  if (!bdtv_5ff6936e1587.test(bdtv_16ca7785d54c)) {
    return false;
  }
  const bdtv_9ec29d2e7f58 = bdtv_16ca7785d54c.replace(/\-/g, "").length;
  return bdtv_9ec29d2e7f58 >= 8;
}

function showErrorMessage(bdtv_dcd2c30d75ae) {
  if (!bdtv_dcd2c30d75ae.classList.contains("bdt-zuvu-entrada2")) {
    bdtv_dcd2c30d75ae.classList.add("bdt-zuvu-entrada2");
  }
}

function removeErrorMessage(bdtv_c39f82c25c97) {
  bdtv_c39f82c25c97.classList.remove("bdt-zuvu-entrada2");
}

function validateFormOnSubmit(bdtv_7eb4652bd11e) {
  const bdtv_f06e17af56ec = bdtv_7eb4652bd11e.closest("form");
  if (!bdtv_f06e17af56ec) return true;

  const bdtv_28f34b65eeca = bdtv_f06e17af56ec.querySelectorAll(`
    input[required][type="text"],
    input[required][type="email"], 
    input[required][type="password"],
    input[required][type="tel"],
    textarea[required],
    select[required]
  `);

  let bdtv_afcf6ba8f72d = true;

  bdtv_28f34b65eeca.forEach((bdtv_8c05a3196a03) => {
    const bdtv_c9434c6e5bd8 =
      bdtv_8c05a3196a03.tagName.toLowerCase() === "textarea"
        ? "textarea"
        : bdtv_8c05a3196a03.tagName.toLowerCase() === "select"
        ? "select"
        : bdtv_8c05a3196a03.type;
    const bdtv_6fcda1d4303e = validateInputByType(bdtv_8c05a3196a03, bdtv_c9434c6e5bd8);

    if (!bdtv_6fcda1d4303e) {
      bdtv_afcf6ba8f72d = false;
    }
  });

  return bdtv_afcf6ba8f72d;
}

function initFormValidation() {
  let bdtv_00666ef89459 = false;

  document.addEventListener(
    "input",
    debounce(function (bdtv_aa94f8218681) {
      const bdtv_4f1f9d26e2b2 = bdtv_aa94f8218681.target;
      const bdtv_a30ba4323bf3 = ["text", "email", "password", "tel"];
      const bdtv_23bafc31e53b = bdtv_4f1f9d26e2b2.tagName.toLowerCase() === "textarea";
      const bdtv_ccb6ef0acb1b = bdtv_4f1f9d26e2b2.tagName.toLowerCase() === "select";

      if (
        bdtv_4f1f9d26e2b2.hasAttribute("required") &&
        (bdtv_a30ba4323bf3.includes(bdtv_4f1f9d26e2b2.type) || bdtv_23bafc31e53b || bdtv_ccb6ef0acb1b) &&
        !bdtv_4f1f9d26e2b2.classList.contains("bdt-ke-bo-kolu")
      ) {
        bdtv_00666ef89459 = true;
        const bdtv_4042200129c8 = bdtv_23bafc31e53b ? "textarea" : bdtv_ccb6ef0acb1b ? "select" : bdtv_4f1f9d26e2b2.type;
        validateInputByType(bdtv_4f1f9d26e2b2, bdtv_4042200129c8);
        bdtv_00666ef89459 = false;
      }
    }, 1500),
    true
  );

  document.addEventListener(
    "focus",
    function (bdtv_7a1edbfad0d6) {
      const bdtv_6ea189bd3409 = bdtv_7a1edbfad0d6.target;
      const bdtv_3d94b81c3b7b = ["text", "email", "password", "tel"];
      const bdtv_daa436e668b5 = bdtv_6ea189bd3409.tagName.toLowerCase() === "textarea";
      const bdtv_bd08331a019e = bdtv_6ea189bd3409.tagName.toLowerCase() === "select";
      if (
        bdtv_6ea189bd3409.hasAttribute("required") &&
        (bdtv_3d94b81c3b7b.includes(bdtv_6ea189bd3409.type) || bdtv_daa436e668b5 || bdtv_bd08331a019e) &&
        bdtv_6ea189bd3409.classList.contains("bdt-zuvu-entrada2") &&
        !bdtv_6ea189bd3409.classList.contains("bdt-ke-bo-kolu")
      ) {
        const bdtv_db0868b8d2b1 = bdtv_daa436e668b5 ? "textarea" : bdtv_bd08331a019e ? "select" : bdtv_6ea189bd3409.type;
        let bdtv_4181dac9b2b2 = false;

        if (bdtv_6ea189bd3409.value.trim()) {
          switch (bdtv_db0868b8d2b1) {
            case "email":
              bdtv_4181dac9b2b2 = isValidEmail(bdtv_6ea189bd3409.value);
              break;
            case "tel":
              bdtv_4181dac9b2b2 = isValidPhone(bdtv_6ea189bd3409.value);
              break;
            case "text":
            case "textarea":
              bdtv_4181dac9b2b2 = bdtv_6ea189bd3409.value.trim().length >= 2;
              break;
            case "select":
              bdtv_4181dac9b2b2 =
                bdtv_6ea189bd3409.value && bdtv_6ea189bd3409.value !== "" && bdtv_6ea189bd3409.value !== "0";
              break;
          }
        }

        if (bdtv_4181dac9b2b2) {
          removeErrorMessage(bdtv_6ea189bd3409);
        }
      }
    },
    true
  );

  document.addEventListener(
    "blur",
    function (bdtv_ff40654c01f6) {
      const bdtv_3a8f05364a56 = bdtv_ff40654c01f6.target;
      const bdtv_df129b09a954 = ["text", "email", "password", "tel"];
      const bdtv_f65162d32aca = bdtv_3a8f05364a56.tagName.toLowerCase() === "textarea";
      const bdtv_b3fa330bc1d5 = bdtv_3a8f05364a56.tagName.toLowerCase() === "select";

      if (
        bdtv_3a8f05364a56.hasAttribute("required") &&
        (bdtv_df129b09a954.includes(bdtv_3a8f05364a56.type) || bdtv_f65162d32aca || bdtv_b3fa330bc1d5) &&
        !bdtv_3a8f05364a56.classList.contains("bdt-ke-bo-kolu")
      ) {
        const bdtv_419c7ecb7796 = bdtv_f65162d32aca ? "textarea" : bdtv_b3fa330bc1d5 ? "select" : bdtv_3a8f05364a56.type;
        validateInputByType(bdtv_3a8f05364a56, bdtv_419c7ecb7796);
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (bdtv_b827d32cd0cf) {
      const bdtv_90045f390dae = bdtv_b827d32cd0cf.target;

      if (
        bdtv_90045f390dae.type === "submit" ||
        bdtv_90045f390dae.getAttribute("type") === "submit" ||
        (bdtv_90045f390dae.tagName.toLowerCase() === "button" &&
          bdtv_90045f390dae.closest("form") &&
          !bdtv_90045f390dae.type) ||
        (bdtv_90045f390dae.tagName.toLowerCase() === "input" && bdtv_90045f390dae.type === "submit")
      ) {
        bdtv_00666ef89459 = true;
        const bdtv_7569cab22da3 = validateFormOnSubmit(bdtv_90045f390dae);
        bdtv_00666ef89459 = false;

        if (!bdtv_7569cab22da3) {
          bdtv_b827d32cd0cf.preventDefault();
          bdtv_b827d32cd0cf.stopPropagation();

          const bdtv_9e7ace22ee77 = bdtv_90045f390dae.closest("form");
          if (bdtv_9e7ace22ee77) {
            const bdtv_270510d9d1ba = bdtv_9e7ace22ee77.querySelector(".bdt-zuvu-entrada2");
            if (bdtv_270510d9d1ba) {
              bdtv_270510d9d1ba.focus();

              setTimeout(() => {
                bdtv_270510d9d1ba.classList.add("bdt-zuvu-entrada2");
                bdtv_270510d9d1ba.reportValidity();
              }, 10);
            }
          }
          return false;
        }
      }
    },
    true
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFormValidation);
} else {
  initFormValidation();
}
